"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateEstimatedSuperStakeLiquidationPrice = exports.calculateSolEarned = exports.findBestSuperStakeIxs = void 0;
const web3_js_1 = require("@solana/web3.js");
const marinade_1 = require("../marinade");
const anchor_1 = require("@coral-xyz/anchor");
const types_1 = require("../types");
const numericConstants_1 = require("../constants/numericConstants");
const node_fetch_1 = __importDefault(require("node-fetch"));
async function findBestSuperStakeIxs({ amount, jupiterClient, driftClient, userAccountPublicKey, marinadePrice, forceMarinade, onlyDirectRoutes, }) {
    if (!marinadePrice) {
        const marinadeProgram = (0, marinade_1.getMarinadeFinanceProgram)(driftClient.provider);
        marinadePrice = await (0, marinade_1.getMarinadeMSolPrice)(marinadeProgram);
    }
    const solMint = driftClient.getSpotMarketAccount(1).mint;
    const mSOLMint = driftClient.getSpotMarketAccount(2).mint;
    let jupiterPrice;
    let bestRoute;
    try {
        const jupiterRoutes = await jupiterClient.getRoutes({
            inputMint: solMint,
            outputMint: mSOLMint,
            amount,
            onlyDirectRoutes,
        });
        bestRoute = jupiterRoutes[0];
        jupiterPrice = bestRoute.inAmount / bestRoute.outAmount;
    }
    catch (e) {
        console.error('Error getting jupiter price', e);
    }
    if (!jupiterPrice || marinadePrice <= jupiterPrice || forceMarinade) {
        const ixs = await driftClient.getStakeForMSOLIx({
            amount,
            userAccountPublicKey,
        });
        return {
            method: 'marinade',
            ixs,
            lookupTables: [],
            price: marinadePrice,
        };
    }
    else {
        const { ixs, lookupTables } = await driftClient.getJupiterSwapIx({
            inMarketIndex: 1,
            outMarketIndex: 2,
            route: bestRoute,
            jupiterClient,
            amount,
            userAccountPublicKey,
        });
        return {
            method: 'jupiter',
            ixs,
            lookupTables,
            price: jupiterPrice,
        };
    }
}
exports.findBestSuperStakeIxs = findBestSuperStakeIxs;
async function calculateSolEarned({ user, depositRecords, }) {
    const now = Date.now() / 1000;
    const timestamps = [
        now,
        ...depositRecords.map((r) => r.ts.toNumber()),
    ];
    const msolRatios = new Map();
    const getPrice = async (timestamp) => {
        const date = new Date(timestamp * 1000); // Convert Unix timestamp to milliseconds
        const swaggerApiDateTime = date.toISOString(); // Format date as swagger API date-time
        const url = `https://api.marinade.finance/msol/price_sol?time=${swaggerApiDateTime}`;
        const response = await (0, node_fetch_1.default)(url);
        if (response.status === 200) {
            const data = await response.json();
            msolRatios.set(timestamp, data);
        }
    };
    await Promise.all(timestamps.map(getPrice));
    let solEarned = numericConstants_1.ZERO;
    for (const record of depositRecords) {
        if (record.marketIndex === 1) {
            if ((0, types_1.isVariant)(record.direction, 'deposit')) {
                solEarned = solEarned.sub(record.amount);
            }
            else {
                solEarned = solEarned.add(record.amount);
            }
        }
        else if (record.marketIndex === 2) {
            const msolRatio = msolRatios.get(record.ts.toNumber());
            const msolRatioBN = new anchor_1.BN(msolRatio * web3_js_1.LAMPORTS_PER_SOL);
            const solAmount = record.amount.mul(msolRatioBN).div(numericConstants_1.LAMPORTS_PRECISION);
            if ((0, types_1.isVariant)(record.direction, 'deposit')) {
                solEarned = solEarned.sub(solAmount);
            }
            else {
                solEarned = solEarned.add(solAmount);
            }
        }
    }
    const currentMSOLTokenAmount = await user.getTokenAmount(2);
    const currentSOLTokenAmount = await user.getTokenAmount(1);
    const currentMSOLRatio = msolRatios.get(now);
    const currentMSOLRatioBN = new anchor_1.BN(currentMSOLRatio * web3_js_1.LAMPORTS_PER_SOL);
    solEarned = solEarned.add(currentMSOLTokenAmount.mul(currentMSOLRatioBN).div(numericConstants_1.LAMPORTS_PRECISION));
    solEarned = solEarned.add(currentSOLTokenAmount);
    return solEarned;
}
exports.calculateSolEarned = calculateSolEarned;
// calculate estimated liquidation price (in mSOL/SOL) based on target amounts
function calculateEstimatedSuperStakeLiquidationPrice(msolDepositAmount, msolMaintenanceAssetWeight, solBorrowAmount, solMaintenanceLiabilityWeight, msolPriceRatio) {
    const liquidationDivergence = (solMaintenanceLiabilityWeight * solBorrowAmount) /
        (msolMaintenanceAssetWeight * msolDepositAmount * msolPriceRatio);
    const liquidationPrice = msolPriceRatio * liquidationDivergence;
    return liquidationPrice;
}
exports.calculateEstimatedSuperStakeLiquidationPrice = calculateEstimatedSuperStakeLiquidationPrice;
